import { Link } from "react-router-dom";
import type { ToolAction, ToolHeaderProps } from "./types";
import styles from "./ToolPage.module.css";
import { useToolEvents } from "./ToolEvents";
export function Action({
  action,
  primary = false,
  onActivate,
}: {
  action: ToolAction;
  primary?: boolean;
  onActivate?: () => void;
}) {
  const className = primary ? styles.primary : styles.secondary;
  if (action.href !== undefined)
    return (
      <Link
        className={className}
        to={action.href}
        aria-disabled={!!action.disabledReason}
        title={action.disabledReason}
        onClick={(e) => {
          if (action.disabledReason) e.preventDefault();
          else onActivate?.();
        }}
      >
        {action.label}
      </Link>
    );
  return (
    <button
      type="button"
      className={className}
      onClick={() => {
        onActivate?.();
        action.onSelect();
      }}
      disabled={!!action.disabledReason || action.pending}
      title={action.disabledReason}
      data-testid={action.testId}
    >
      {action.pending ? "Please wait…" : action.label}
    </button>
  );
}
export function ToolHeader({
  title,
  description,
  primaryAction,
  secondaryActions,
  help,
}: ToolHeaderProps) {
  const track = useToolEvents();
  return (
    <header className={styles.header}>
      <div className={styles.heading}>
        <h1>{title}</h1>
        {description && <p>{description}</p>}
        {help}
      </div>
      <div className={styles.actions}>
        {secondaryActions?.map((action) => (
          <Action key={action.label} action={action} />
        ))}
        {primaryAction && (
          <Action
            action={primaryAction}
            primary
            onActivate={() => track?.("primary_action_opened")}
          />
        )}
      </div>
      {primaryAction?.disabledReason && (
        <p className={styles.actionReason} role="status">
          {primaryAction.disabledReason}
        </p>
      )}
    </header>
  );
}
